import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'jsonHighlight' })
export class JsonHighlightPipe implements PipeTransform {
  transform(json: string): string {
    if (!json) return '';

    // Escape HTML
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

    // Regex for different JSON types
    return json.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|\b-?\d+(\.\d+)?([eE][+-]?\d+)?\b)/g,
      (match) => {
        let cls = 'number';

        if (/^"/.test(match)) {
          cls = /:$/.test(match) ? 'key' : 'string';
        } else if (/true|false/.test(match)) {
          cls = 'boolean';
        } else if (/null/.test(match)) {
          cls = 'null';
        }

        return `<span class="${cls}">${match}</span>`;
      }
    );
  }
}
